
import {
    defineComponent,
    onMounted,
    ref
} from "vue"
import {
    useRouter,
    useRoute
} from 'vue-router';

//libs 
import Swal from "sweetalert2/dist/sweetalert2.min.js";

//servicios
import Auth from "@/core/services/AuthService"

export default defineComponent({
    name: "ActivateAccount",
    setup() {
        const route = useRoute();
        const router = useRouter();
        const fullscreenLoading = ref(false)
        const { id } = route.params
        const resp = ref({
            status: '',
            message: ''
        });

        const activate = async () => {
            fullscreenLoading.value = true
            await Auth.activateAccount(id)
                .then((res) => {
                    resp.value = res.data
                    fullscreenLoading.value = false
                }).catch(({
                    response
                }) => {
                    fullscreenLoading.value = false
                    Swal.fire({
                        title: 'Mesa de Partes Virtual FEDUP',
                        text: response.data.messages.error,
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: "Intentar otra vez!",
                        customClass: {
                            confirmButton: "btn fw-bold btn-light-danger",
                        },
                    });
                })
        }

        const goMpv = () => {
            router.push({
                name: "sign-in"
            })
        }

        onMounted(() => {
            activate()
        })

        return {
            id,
            goMpv,
            resp,
            fullscreenLoading
        }

    }
})
